;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { z } from 'zod'

export const NEXT_PUBLIC_VERCEL_ENV = z
  .enum(['development', 'preview', 'production'])
  .parse(process.env.NEXT_PUBLIC_VERCEL_ENV)
